import React from 'react';
import '../styles/ProcessDevice.css';

import semiconductor1 from "../assets/semiconductor1.png";
import semiconductor8 from "../assets/semiconductor8.png";
import semiconductor9 from "../assets/semiconductor9.png";
import semiconductor10 from "../assets/semiconductor10.png";
import semiconductor11 from "../assets/semiconductor11.png";

const devices = [
  {
    title: "Transparent body detection",
    text: "Detect the floating of the wafer to prevent accidents.",
    img: semiconductor1
  },
  {
    title: "Inspection",
    text: "Check whether the wafer placement is accurate",
    img: semiconductor8
  },
  {
    title: "Check for presence",
    text: "Frequency State Modulation",
    img: semiconductor9
  },
  {
    title: "Safety confirmation",
    text: "Measuring the basic flatness of glass.",
    img: semiconductor10
  },
  {
    title: "Positioning",
    text: "Use cameras to locate lithium batteries and detect product defects.",
    img: semiconductor11
  }
];

const processdevices = () => {
  return (
    <section className="process-devices">
      {devices.map((item, idx) => (
        <div className={`process-device-row ${idx % 2 !== 0 ? 'reverse' : ''}`} key={idx}>
          <div className="device-image">
            <img src={item.img} alt={item.title} />
          </div>
          <div className="device-text">
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        </div>
      ))}
    </section>
  );
};

export default processdevices;
